export default {
	setupWizard_appearance_caption: 'Wähle Theme-Modus und Akzentfarbe.',
	setupWizard_appearance_title: 'Erscheinungsbild',

	setupWizard_back: 'Zurück',
	setupWizard_defer: 'Später',
	setupWizard_features_caption: 'Aktiviere optionale Funktionen.',
	setupWizard_features_title: 'Funktionen',
	setupWizard_finish: 'Loslegen',
	setupWizard_get_started: "Los geht's",

	setupWizard_layout_caption: 'Feinjustage für Icons, Buttons, Navigation und Lesbarkeit.',
	setupWizard_layout_title: 'Buttons, Icons & Layout',
	setupWizard_next: 'Weiter',
	setupWizard_settings_relaunch_button: 'Assistent öffnen',

	setupWizard_settings_relaunch_caption: 'Führt Sie noch einmal durch die wichtigsten Einstellungen.',
	setupWizard_settings_relaunch_label: 'Einrichtungsassistent erneut starten',

	setupWizard_settings_relaunch_title: 'Einrichtungsassistent',
	setupWizard_skip: 'Setup überspringen',

	setupWizard_summary_buttons: 'Buttons',
	setupWizard_summary_caption: 'Sie können jeden Punkt jederzeit unter Einstellungen → Arbeitsbereich ändern.',
	setupWizard_summary_features: 'Funktionen',
	setupWizard_summary_layout: 'Layout',
	setupWizard_summary_separator: ' · ',
	setupWizard_summary_theme: 'Theme',
	setupWizard_summary_title: 'Alles bereit{name}!',
	setupWizard_summary_work_mode: 'Arbeitsmodus',

	setupWizard_welcome_card_appearance_caption: 'Modus, Primärfarbe, Oberfläche',
	setupWizard_welcome_card_features_caption: 'Timer, Spotlight-Suche, Benutzerliste',
	setupWizard_welcome_card_layout_caption: 'Schriftgröße, Icon-Stil, Buttons, Navigation',
	setupWizard_welcome_card_work_mode_caption: 'Tab-Arbeitsbereich oder Fokus-Ansicht',

	setupWizard_welcome_footnote: 'Sie können alles später unter Einstellungen ändern.',
	setupWizard_welcome_subtitle: 'Lassen Sie uns Ihre Arbeitsumgebung in wenigen Schritten einrichten.',
	setupWizard_welcome_title: 'Willkommen{name}!',
	setupWizard_work_mode_caption:
		'Wählen Sie, wie infra-struktur Module und Datensätze anordnet. Sie können das jederzeit unter Einstellungen ändern.',
	setupWizard_work_mode_focus_description:
		'Ohne Tab-Leiste: Navigation über das Menü, Liste und geöffneter Eintrag nebeneinander — aufgeräumt und fokussiert.',
	setupWizard_work_mode_focus_title: 'Fokus-Ansicht',
	setupWizard_work_mode_tabs_description:
		'Module und Datensätze öffnen als eigene Tabs in voller Breite — wie aus der bisherigen infra-struktur-Oberfläche gewohnt.',
	setupWizard_work_mode_tabs_title: 'Tab-Arbeitsbereich',
	setupWizard_work_mode_title: 'Arbeitsmodus',
};
